import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {IndexComponent} from "./pages/index/index.component";
import {NovoComponent} from "./pages/novo/novo.component";
import {DetalhesComponent} from "./pages/detalhes/detalhes.component";
import {AutenticacaoGuard} from "../../../core/guards/autenticacao-guard";
import {ConfirmarEmailComponent} from "./pages/confirmar-email/confirmar-email.component";
import {ConfiguracoesComponent} from "./pages/configuracoes/configuracoes.component";

const routes: Routes = [
  { path: "usuarios", component: IndexComponent, canActivate: [AutenticacaoGuard] },
  { path: "usuarios/novo", component: NovoComponent, canActivate: [AutenticacaoGuard] },
  { path: "conta", component: DetalhesComponent, canActivate: [AutenticacaoGuard] },
  { path: "planos/:id", component: DetalhesComponent, canActivate: [AutenticacaoGuard] },
  { path: "confirmar-email/:token", component: ConfirmarEmailComponent },
  { path: "configuracoes", component: ConfiguracoesComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsuarioRoutingModule { }
